import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

/**
 * Opens a dialog and returns an Observable that emits the result when the dialog is closed. Material Dialog version is 16 and up.
 * Ideally works with stand-alone components or templates.
 *
 * @param dialogClassRef The component class or template to be used as the content of the dialog.
 * @param data Optional data to be passed to the dialog.
 * @param dialogOptions Optional configuration for the dialog.
 * @returns An Observable that emits the result of the dialog when it is closed.
 */
@Injectable({ providedIn: 'root' })
export class DialogService {
  constructor(private dialog: MatDialog) {}

  openDialog<T = any>(dialogClassRef: any, data?: any, dialogOptions?: any): Observable<T extends any ? T : any> {
    dialogOptions = {
      position: { top: '0px' },
      minWidth: '40%',
      disableClose: false,
      panelClass: 'alert-modals',
      ...dialogOptions,
    };

    return this.dialog
      .open(dialogClassRef, { ...dialogOptions, data })
      .afterClosed()
      .pipe(take(1));
  }
}
